const features = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '无需下载即点即看',
    desc: '51漫画在线观看无需安装任何应用，打开浏览器即可畅读全本漫画，节省手机存储空间。',
  },
  {
    icon: 'ri-arrow-down-line',
    title: '下拉式流畅阅读',
    desc: '独创的下拉式加载技术，手指下滑即可连续阅读，无需频繁点击翻页，阅读体验如丝般顺滑。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质全彩呈现',
    desc: '所有漫画均以高清分辨率呈现，51漫画在线看全集每一格分镜都清晰锐利，还原原作细节。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日快速更新',
    desc: '编辑团队7×24小时跟进热门连载，每日更新超过200话，51漫画免费看永不断更。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备自适应',
    desc: '手机、平板、电脑全平台完美适配，51漫画在线阅读随时随地，不受设备限制。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-600">为什么数百万读者选择51漫画网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 border border-background-200/70 text-center cursor-pointer hover:border-primary-200 transition-all group">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}